import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

// The watch page loads in its own chunk with the player code (spec 032): no other page loads
// anything from YouTube, and the initial JS stays as it is.
const WatchPage = lazy(() => import('../components/watch/WatchPage.js'))

export const Route = createFileRoute('/watch/$source/$item')({
  component: function Watch() {
    const { source, item } = Route.useParams()
    return (
      <Suspense fallback={null}>
        <WatchPage source={source} item={item} />
      </Suspense>
    )
  },
})
